export const getGoogleMapApiKey = () => {
  const apiKey = "AIzaSyBR1wSEKxnBVVMCE4LymLcxzotC03WwqRk";
  return apiKey;
};

export const GOOGLE_MAPS_SCRIPT_ID = 'google-map-script';
export const GOOGLE_MAPS_LIBRARIES = ['places'];
